module.exports = __webpack_public_path__ + "img/overview-mc-donald.e91201ef.webp";